import o from "./index944.js";
import r from "./index820.js";
var m = o(r, "Promise");
export {
  m as default
};
